export default function (state, val) {
    let data = [];
    let items = val.Items;

    items.forEach(i => {
        let item = data.filter(j => {
            return j.currency === i.CurrencyId;
        })[0];
        if (!item) {
            data.push({
                currency: i.CurrencyId,
                amount: 1,
                planed: i.PlanedPaymentSum, //Запланировано
                nonPlaned: (i.Sum - i.PlanedPaymentSum) > 0 ? (i.Sum - i.PlanedPaymentSum) : 0, //Не запланировано
                payed: i.ActualPaymentSum,  //Оплаченно
                overPayments: (i.ActualPaymentSum - i.Sum) > 0 ? (i.ActualPaymentSum - i.Sum) : 0,  //Переплата
                sum: i.Sum,
            });
        } else {
            item.amount++;
            item.planed += i.PlanedPaymentSum;
            item.nonPlaned += (i.Sum - i.PlanedPaymentSum) > 0 ? (i.Sum - i.PlanedPaymentSum) : 0;
            item.payed += i.ActualPaymentSum;
            item.overPayments += (i.ActualPaymentSum - i.Sum) > 0 ? (i.ActualPaymentSum - i.Sum) : 0;
            item.sum += i.Sum;
        }
    });
    state.items = data;
}